import ApiService from 'app/services/ApiService';

//Internal Employees types
export const FETCH_INTERNAL_EMPLOYEE_REQUEST = 'FETCH_INTERNAL_EMPLOYEE_REQUEST';
export const FETCH_INTERNAL_EMPLOYEE_SUCCESS = 'FETCH_INTERNAL_EMPLOYEE_SUCCESS';
export const FETCH_INTERNAL_EMPLOYEE_FAILURE = 'FETCH_INTERNAL_EMPLOYEE_FAILURE';

export const EXPORT_INTERNAL_EMPLOYEE_REQUEST = 'EXPORT_INTERNAL_EMPLOYEE_REQUEST';
export const EXPORT_INTERNAL_EMPLOYEE_SUCCESS = 'EXPORT_INTERNAL_EMPLOYEE_SUCCESS';
export const EXPORT_INTERNAL_EMPLOYEE_FAILURE = 'EXPORT_INTERNAL_EMPLOYEE_FAILURE';

export const GET_INTERNAL_EMPLOYEE_NAMES_REQUEST = 'GET_INTERNAL_EMPLOYEE_NAMES_REQUEST';
export const GET_INTERNAL_EMPLOYEE_NAMES_SUCCESS = 'GET_INTERNAL_EMPLOYEE_NAMES_SUCCESS';
export const GET_INTERNAL_EMPLOYEE_NAMES_FAILURE = 'GET_INTERNAL_EMPLOYEE_NAMES_FAILURE';

export const GET_INTERNAL_EMPLOYEE_SUBDIRECTION_REQUEST = 'GET_INTERNAL_EMPLOYEE_SUBDIRECTION_REQUEST';
export const GET_INTERNAL_EMPLOYEE_SUBDIRECTION_SUCCESS = 'GET_INTERNAL_EMPLOYEE_SUBDIRECTION_SUCCESS';
export const GET_INTERNAL_EMPLOYEE_SUBDIRECTION_FAILURE = 'GET_INTERNAL_EMPLOYEE_SUBDIRECTION_FAILURE';

export const GET_INTERNAL_EMPLOYEE_ID_REQUEST = 'GET_INTERNAL_EMPLOYEE_ID_REQUEST';
export const GET_INTERNAL_EMPLOYEE_ID_SUCCESS = 'GET_INTERNAL_EMPLOYEE_ID_SUCCESS';
export const GET_INTERNAL_EMPLOYEE_ID_FAILURE = 'GET_INTERNAL_EMPLOYEE_ID_FAILURE';

export const GET_INTERNAL_EMPLOYEE_COMPANY_REQUEST = 'GET_INTERNAL_EMPLOYEE_COMPANY_REQUEST';
export const GET_INTERNAL_EMPLOYEE_COMPANY_SUCCESS = 'GET_INTERNAL_EMPLOYEE_COMPANY_SUCCESS';
export const GET_INTERNAL_EMPLOYEE_COMPANY_FAILURE = 'GET_INTERNAL_EMPLOYEE_COMPANY_FAILURE';

export const GET_INTERNAL_EMPLOYEE_CATEGORY_REQUEST = 'GET_INTERNAL_EMPLOYEE_CATEGORY_REQUEST';
export const GET_INTERNAL_EMPLOYEE_CATEGORY_SUCCESS = 'GET_INTERNAL_EMPLOYEE_CATEGORY_SUCCESS';
export const GET_INTERNAL_EMPLOYEE_CATEGORY_FAILURE = 'GET_INTERNAL_EMPLOYEE_CATEGORY_FAILURE';

export const GET_INTERNAL_EMPLOYEE_CONTRACT_REQUEST = 'GET_INTERNAL_EMPLOYEE_CONTRACT_REQUEST';
export const GET_INTERNAL_EMPLOYEE_CONTRACT_SUCCESS = 'GET_INTERNAL_EMPLOYEE_CONTRACT_SUCCESS';
export const GET_INTERNAL_EMPLOYEE_CONTRACT_FAILURE = 'GET_INTERNAL_EMPLOYEE_CONTRACT_FAILURE';

export const GET_INTERNAL_EMPLOYEE_OT_REQUEST = 'GET_INTERNAL_EMPLOYEE_OT_REQUEST';
export const GET_INTERNAL_EMPLOYEE_OT_SUCCESS = 'GET_INTERNAL_EMPLOYEE_OT_SUCCESS';
export const GET_INTERNAL_EMPLOYEE_OT_FAILURE = 'GET_INTERNAL_EMPLOYEE_OT_FAILURE';

export const GET_INTERNAL_EMPLOYEE_EMAIL_REQUEST = 'GET_INTERNAL_EMPLOYEE_EMAIL_REQUEST';
export const GET_INTERNAL_EMPLOYEE_EMAIL_SUCCESS = 'GET_INTERNAL_EMPLOYEE_EMAIL_SUCCESS';
export const GET_INTERNAL_EMPLOYEE_EMAIL_FAILURE = 'GET_INTERNAL_EMPLOYEE_EMAIL_FAILURE';

export const GET_INTERNAL_EMPLOYEE_CECO_REQUEST = 'GET_INTERNAL_EMPLOYEE_CECO_REQUEST';
export const GET_INTERNAL_EMPLOYEE_CECO_SUCCESS = 'GET_INTERNAL_EMPLOYEE_CECO_SUCCESS';
export const GET_INTERNAL_EMPLOYEE_CECO_FAILURE = 'GET_INTERNAL_EMPLOYEE_CECO_FAILURE';

export const GET_INTERNAL_EMPLOYEE_EPEP_REQUEST = 'GET_INTERNAL_EMPLOYEE_EPEP_REQUEST';
export const GET_INTERNAL_EMPLOYEE_EPEP_SUCCESS = 'GET_INTERNAL_EMPLOYEE_EPEP_SUCCESS';
export const GET_INTERNAL_EMPLOYEE_EPEP_FAILURE = 'GET_INTERNAL_EMPLOYEE_EPEP_FAILURE';

export const GET_INTERNAL_COMUNICATIONPROGRAM_REQUEST = 'GET_INTERNAL_COMUNICATIONPROGRAM_REQUEST';
export const GET_INTERNAL_COMUNICATIONPROGRAM_SUCCESS = 'GET_INTERNAL_COMUNICATIONPROGRAM_SUCCESS';
export const GET_INTERNAL_COMUNICATIONPROGRAM_FAILURE= 'GET_INTERNAL_COMUNICATIONPROGRAM_FAILURE';

export const GET_INTERNAL_PERNOCTA_REQUEST = 'GET_INTERNAL_PERNOCTA_REQUEST';
export const GET_INTERNAL_PERNOCTA_SUCCESS = 'GET_INTERNAL_PERNOCTA_SUCCESS';
export const GET_INTERNAL_PERNOCTA_FAILURE = 'GET_INTERNAL_PERNOCTA_FAILURE';

export const GET_INTERNAL_COURSE_REQUEST = 'GET_INTERNAL_COURSE_REQUEST';
export const GET_INTERNAL_COURSE_SUCCESS = 'GET_INTERNAL_COURSE_SUCCESS';
export const GET_INTERNAL_COURSE_FAILURE= 'GET_INTERNAL_COURSE_FAILURE';

//External employees Types
export const FETCH_EXTERNAL_EMPLOYEE_REQUEST = 'FETCH_EXTERNAL_EMPLOYEE_REQUEST';
export const FETCH_EXTERNAL_EMPLOYEE_SUCCESS = 'FETCH_EXTERNAL_EMPLOYEE_SUCCESS';
export const FETCH_EXTERNAL_EMPLOYEE_FAILURE = 'FETCH_EXTERNAL_EMPLOYEE_FAILURE';

export const EXPORT_EXTERNAL_EMPLOYEE_REQUEST = 'EXPORT_EXTERNAL_EMPLOYEE_REQUEST';
export const EXPORT_EXTERNAL_EMPLOYEE_SUCCESS = 'EXPORT_EXTERNAL_EMPLOYEE_SUCCESS';
export const EXPORT_EXTERNAL_EMPLOYEE_FAILURE = 'EXPORT_EXTERNAL_EMPLOYEE_FAILURE';

export const GET_EXTERNAL_EMPLOYEE_NAMES_REQUEST = 'GET_EXTERNAL_EMPLOYEE_NAMES_REQUEST';
export const GET_EXTERNAL_EMPLOYEE_NAMES_SUCCESS = 'GET_EXTERNAL_EMPLOYEE_NAMES_SUCCESS';
export const GET_EXTERNAL_EMPLOYEE_NAMES_FAILURE = 'GET_EXTERNAL_EMPLOYEE_NAMES_FAILURE';

export const GET_EXTERNAL_EMPLOYEE_EMAIL_REQUEST = 'GET_EXTERNAL_EMPLOYEE_EMAIL_REQUEST';
export const GET_EXTERNAL_EMPLOYEE_EMAIL_SUCCESS = 'GET_EXTERNAL_EMPLOYEE_EMAIL_SUCCESS';
export const GET_EXTERNAL_EMPLOYEE_EMAIL_FAILURE = 'GET_EXTERNAL_EMPLOYEE_EMAIL_FAILURE';

export const CLEAR_REDUCER = 'CLEAR_REDUCER';
export const SAVE_FILTER = 'SAVE_FILTER';
export const SAVE_FILTER_EXTERNAL = 'SAVE_FILTER_EXTERNAL';
export const SAVE_PAGINATION = 'SAVE_PAGINATION';
export const SAVE_PAGINATION_EXTERNAL = 'SAVE_PAGINATION_EXTERNAL';

//Kardex
export const FETCH_KARDEX_REQUEST = 'FETCH_KARDEX_REQUEST'
export const FETCH_KARDEX_SUCCESS = 'FETCH_KARDEX_SUCCESS'
export const FETCH_KARDEX_FAILURE = 'FETCH_KARDEX_FAILURE'

export const EXPORT_KARDEX_REQUEST = 'EXPORT_KARDEX_REQUEST'
export const EXPORT_KARDEX_SUCCESS = 'EXPORT_KARDEX_SUCCESS'
export const EXPORT_KARDEX_FAILURE = 'EXPORT_KARDEX_FAILURE'

export const EXPORT_BOOKMARK_EMPLOYEE_REQUEST = 'EXPORT_BOOKMARK_EMPLOYEE_REQUEST';
export const EXPORT_BOOKMARK_EMPLOYEE_SUCCESS = 'EXPORT_BOOKMARK_EMPLOYEE_SUCCESS';
export const EXPORT_BOOKMARK_EMPLOYEE_FAILURE = 'EXPORT_BOOKMARK_EMPLOYEE_FAILURE';

export const EXPORT_KARDEX_EMPLOYEE_REQUEST = 'EXPORT_KARDEX_EMPLOYEE_REQUEST';
export const EXPORT_KARDEX_EMPLOYEE_SUCCESS = 'EXPORT_KARDEX_EMPLOYEE_SUCCESS';
export const EXPORT_KARDEX_EMPLOYEE_FAILURE = 'EXPORT_KARDEX_EMPLOYEE_FAILURE';

//Internal Employees Actions
export const getInternalEmployeesNames = (listNames) => dispatch => {
    dispatch({ type: GET_INTERNAL_EMPLOYEE_NAMES_REQUEST });
    ApiService.getInternalEmployeesNames({ listNames }).then(
        response => {
            dispatch({
                type: GET_INTERNAL_EMPLOYEE_NAMES_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_INTERNAL_EMPLOYEE_NAMES_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const getInternalEmployeesSubdirection = () => dispatch => {
    dispatch({ type: GET_INTERNAL_EMPLOYEE_SUBDIRECTION_REQUEST });
    ApiService.getInternalEmployeesSubdirection().then(
        response => {
            dispatch({
                type: GET_INTERNAL_EMPLOYEE_SUBDIRECTION_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_INTERNAL_EMPLOYEE_SUBDIRECTION_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const getInternalEmployeesId = (listFiles) => dispatch => {
    dispatch({ type: GET_INTERNAL_EMPLOYEE_ID_REQUEST });
    ApiService.getInternalEmployeesId({ listFiles }).then(
        response => {
            dispatch({
                type: GET_INTERNAL_EMPLOYEE_ID_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_INTERNAL_EMPLOYEE_ID_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const getInternalEmployeesCompany = () => dispatch => {
    dispatch({ type: GET_INTERNAL_EMPLOYEE_COMPANY_REQUEST });
    ApiService.getInternalEmployeesCompany().then(
        response => {
            dispatch({
                type: GET_INTERNAL_EMPLOYEE_COMPANY_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_INTERNAL_EMPLOYEE_COMPANY_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const getInternalEmployeesCategory = (listJobs) => dispatch => {
    dispatch({ type: GET_INTERNAL_EMPLOYEE_CATEGORY_REQUEST });
    ApiService.getInternalEmployeesCategory({ listJobs }).then(
        response => {
            dispatch({
                type: GET_INTERNAL_EMPLOYEE_CATEGORY_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_INTERNAL_EMPLOYEE_CATEGORY_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const getInternalEmployeesContract = () => dispatch => {
    dispatch({ type: GET_INTERNAL_EMPLOYEE_CONTRACT_REQUEST });
    ApiService.getInternalEmployeesContract().then(
        response => {
            dispatch({
                type: GET_INTERNAL_EMPLOYEE_CONTRACT_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_INTERNAL_EMPLOYEE_CONTRACT_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const getInternalEmployeesOt = () => dispatch => {
    dispatch({ type: GET_INTERNAL_EMPLOYEE_OT_REQUEST });
    ApiService.getInternalEmployeesOt().then(
        response => {
            dispatch({
                type: GET_INTERNAL_EMPLOYEE_OT_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_INTERNAL_EMPLOYEE_OT_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const getInternalEmployeesEmail = (emailInternal) => dispatch => {
    dispatch({ type: GET_INTERNAL_EMPLOYEE_EMAIL_REQUEST });
    ApiService.getInternalEmployeesEmail({ listEmails: emailInternal }).then(
        response => {
            dispatch({
                type: GET_INTERNAL_EMPLOYEE_EMAIL_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_INTERNAL_EMPLOYEE_EMAIL_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const getInternalEmployeesCeco = () => dispatch => {
    dispatch({ type: GET_INTERNAL_EMPLOYEE_CECO_REQUEST });
    ApiService.getInternalEmployeesCeco().then(
        response => {
            dispatch({
                type: GET_INTERNAL_EMPLOYEE_CECO_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_INTERNAL_EMPLOYEE_CECO_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const getInternalEmployeesEpep = () => dispatch => {
    dispatch({ type: GET_INTERNAL_EMPLOYEE_EPEP_REQUEST });
    ApiService.getInternalEmployeesEpep().then(
        response => {
            dispatch({
                type: GET_INTERNAL_EMPLOYEE_EPEP_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_INTERNAL_EMPLOYEE_EPEP_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const fetchInternalEmployees = (data) => dispatch => {
    dispatch({ type: FETCH_INTERNAL_EMPLOYEE_REQUEST });
    ApiService.fetchInternalEmployees(data).then(
        response => {
            dispatch({
                type: FETCH_INTERNAL_EMPLOYEE_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: FETCH_INTERNAL_EMPLOYEE_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const exportXls = (param) => dispatch => {
    let objValidate = {}

    for (const [key, value] of Object.entries(param)) {
        if (value) {
            objValidate[key] = value
        }
    }

    dispatch({ type: EXPORT_INTERNAL_EMPLOYEE_REQUEST });
    ApiService.exportUserSearch(objValidate).then(
        result => {
            const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            downloadFile(blob, "Busqueda_Colaboradores_Internos.xlsx");

            dispatch({ type: EXPORT_INTERNAL_EMPLOYEE_SUCCESS });
        }
    ).catch(
        (error) => dispatch({ type: EXPORT_INTERNAL_EMPLOYEE_FAILURE, payload: error.message })
    )
}

export const getInternalPernoctas = (data) => dispatch => {
    dispatch({ type: GET_INTERNAL_PERNOCTA_REQUEST });
    ApiService.getInternalPercnota().then(
        response => {
            dispatch({
                type: GET_INTERNAL_PERNOCTA_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_INTERNAL_PERNOCTA_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const getInternalComunicationPrograms = (data) => dispatch => {
    dispatch({ type: GET_INTERNAL_COMUNICATIONPROGRAM_REQUEST });
    ApiService.getInternalComunicationProgram().then(
        response => {
            dispatch({
                type: GET_INTERNAL_COMUNICATIONPROGRAM_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_INTERNAL_COMUNICATIONPROGRAM_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const getInternalCourses = (data) => dispatch => {
    dispatch({ type: GET_INTERNAL_COURSE_REQUEST });
    ApiService.getInternalCourse().then(
        response => {
            dispatch({
                type: GET_INTERNAL_COURSE_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_INTERNAL_COURSE_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

//External Employees Actions
export const getExternalEmployeesNames = (listNames) => dispatch => {
    dispatch({ type: GET_EXTERNAL_EMPLOYEE_NAMES_REQUEST });
    ApiService.getExternalEmployeesNames({ listNames }).then(
        response => {
            dispatch({
                type: GET_EXTERNAL_EMPLOYEE_NAMES_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_EXTERNAL_EMPLOYEE_NAMES_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const getExternalEmployeesEmail = (listEmails) => dispatch => {
    dispatch({ type: GET_EXTERNAL_EMPLOYEE_EMAIL_REQUEST });
    ApiService.getExternalEmployeesEmail({ listEmails }).then(
        response => {
            dispatch({
                type: GET_EXTERNAL_EMPLOYEE_EMAIL_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_EXTERNAL_EMPLOYEE_EMAIL_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const fetchExternalEmployees = (data) => dispatch => {
    dispatch({ type: FETCH_EXTERNAL_EMPLOYEE_REQUEST });
    ApiService.fetchExternalEmployees(data).then(
        response => {
            dispatch({
                type: FETCH_EXTERNAL_EMPLOYEE_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: FETCH_EXTERNAL_EMPLOYEE_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const exportExternalXls = (param) => dispatch => {
    let objValidate = {}

    for (const [key, value] of Object.entries(param)) {
        if (value) {
            objValidate[key] = value
        }
    }

    dispatch({ type: EXPORT_EXTERNAL_EMPLOYEE_REQUEST });
    ApiService.exportUserSearchExternal(objValidate).then(
        result => {
            const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            downloadFile(blob, "Busqueda_Colaboradores_Externos.xlsx");

            dispatch({ type: EXPORT_EXTERNAL_EMPLOYEE_SUCCESS });
        }
    ).catch(
        (error) => dispatch({ type: EXPORT_EXTERNAL_EMPLOYEE_FAILURE, payload: error.message })
    )
}

//Kardex
export const fetchKardex = (data) => dispatch => {
    dispatch({ type: FETCH_KARDEX_REQUEST });
    ApiService.fetchKardex(data).then(
        response => {
            dispatch({
                type: FETCH_KARDEX_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: FETCH_KARDEX_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const exportKardexXls = (param) => dispatch => {
    let objValidate = {}

    for (const [key, value] of Object.entries(param)) {
        if (value) {
            objValidate[key] = value
        }
    }

    dispatch({ type: EXPORT_KARDEX_REQUEST });
    ApiService.exportKardex(objValidate).then(
        result => {
            const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            downloadFile(blob, `KardexColaborador_${param.employeeId}.xlsx`);

            dispatch({ type: EXPORT_KARDEX_SUCCESS });
        }
    ).catch(
        (error) => dispatch({ type: EXPORT_KARDEX_FAILURE, payload: error.message })
    )
}

export const exportBookmark = (param, title) => dispatch => {
    let objValidate = {}

    for (const [key, value] of Object.entries(param)) {
        if (value) {
            objValidate[key] = value
        }
    }

    dispatch({ type: EXPORT_BOOKMARK_EMPLOYEE_REQUEST });
    ApiService.exportUserBookmark(objValidate).then(
        result => {
            const blob = new Blob([result], { type: 'application/pdf' });
            downloadFile(blob, `Bookmark_Colaboradores_${title}.pdf`);

            dispatch({ type: EXPORT_BOOKMARK_EMPLOYEE_SUCCESS });
        }
    ).catch(
        (error) => dispatch({ type: EXPORT_BOOKMARK_EMPLOYEE_FAILURE, payload: error.message })
    )
}

export const exportKardexBookmark = (param, title) => dispatch => {
    let objValidate = {}

    for (const [key, value] of Object.entries(param)) {
        if (value) {
            objValidate[key] = value
        }
    }

    dispatch({ type: EXPORT_KARDEX_EMPLOYEE_REQUEST });
    ApiService.exportUserKardex(objValidate).then(
        result => {
            const blob = new Blob([result], { type: 'application/pdf' });
            downloadFile(blob, `Bookmark_Kardex_${title}.pdf`);

            dispatch({ type: EXPORT_KARDEX_EMPLOYEE_SUCCESS });
        }
    ).catch(
        (error) => dispatch({ type: EXPORT_KARDEX_EMPLOYEE_FAILURE, payload: error.message })
    )
}

//Guardar filtros, paginación y reiniciar reducer
export const clear = () => ({
    type: CLEAR_REDUCER
});

export const saveFilter = (filter) => ({
    type: SAVE_FILTER,
    payload: filter
});

export const saveFilterExternal = (filter) => ({
    type: SAVE_FILTER_EXTERNAL,
    payload: filter
});

export const savePagination = (pagination) => ({
    type: SAVE_PAGINATION,
    payload: pagination
});

export const savePaginationExternal = (pagination) => ({
    type: SAVE_PAGINATION_EXTERNAL,
    payload: pagination
});

//Utilidades

const downloadFile = (blob, fileName) => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
};